import { Helmet } from 'react-helmet-async';

import { Content } from './components/Content';

export const AdminCanvasCourseStudentsPage = () => {
  return (
    <>
      <Helmet>
        <title>Canvas Course Students List - AutoScript Admin</title>
      </Helmet>

      <Content />
    </>
  );
};
